'use client';

import { useState, useRef } from 'react';
import useIsomorphicLayoutEffect from './useIsomorphicLayoutEffect.js';

/**
 * Older versions of Safari (shipped withCatalina and before) do not support addEventListener on matchMedia
 * https://stackoverflow.com/questions/56466261/matchmedia-addlistener-marked-as-deprecated-addeventlistener-equivalent
 * */
function attachMediaListener(query, callback) {
    try {
        query.addEventListener('change', callback);
        return function () { return query.removeEventListener('change', callback); };
    }
    catch (e) {
        query.addListener(callback);
        return function () { return query.removeListener(callback); };
    }
}
function getInitialValue(query, initialValue) {
    if (typeof initialValue === 'boolean') {
        return initialValue;
    }
    if (typeof window !== 'undefined' && 'matchMedia' in window) {
        return window.matchMedia(query).matches;
    }
    return false;
}
function useMediaQuery(query, initialValue, _a) {
    var _b = _a === void 0 ? {
        getInitialValueInEffect: true
    } : _a, getInitialValueInEffect = _b.getInitialValueInEffect;
    var _c = useState(getInitialValueInEffect ? initialValue : getInitialValue(query, initialValue)), matches = _c[0], setMatches = _c[1];
    var queryRef = useRef();
    useIsomorphicLayoutEffect(function () {
        if ('matchMedia' in window) {
            queryRef.current = window.matchMedia(query);
            setMatches(queryRef.current.matches);
            return attachMediaListener(queryRef.current, function (event) { return setMatches(event.matches); });
        }
        return undefined;
    }, [query]);
    return matches;
}

export { useMediaQuery as default };
//# sourceMappingURL=useMediaQuery.js.map
